import React, { FunctionComponent } from "react";

const ShareIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/interface-essential/share/share
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.500 11.250 A3.750 3.750 0 1 0 9.000 11.250 A3.750 3.750 0 1 0 1.500 11.250 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M15.000 6.000 A3.750 3.750 0 1 0 22.500 6.000 A3.750 3.750 0 1 0 15.000 6.000 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M15.000 18.000 A3.750 3.750 0 1 0 22.500 18.000 A3.750 3.750 0 1 0 15.000 18.000 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M8.746 9.891L15.254 7.36"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M8.605 12.928L15.395 16.323"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default ShareIcon;
